import * as React from "react";

import {useGuideState} from "@repo/guide-state";

import PageDisplayProvider from "#data-access/page-display-provider.tsx";
import SiteFooter from "#page-package/site-footer.tsx";

export const Footer = () => {
    const guideOpen = useGuideState("open");

    return (
        <PageDisplayProvider>
            {({footer}) => {
                if (!footer) {
                    return null;
                }

                return (
                    <div id="footer">
                        <SiteFooter khanmigoSidebarOpen={guideOpen} />
                    </div>
                );
            }}
        </PageDisplayProvider>
    );
};
